export const CUSTOMER_LINKS_REQUEST = 'CUSTOMIZATION_CUSTOMER_LINKS_REQUEST';
export const CUSTOMER_LINKS_SUCCESS = 'CUSTOMIZATION_CUSTOMER_LINKS_SUCCESS';
export const CUSTOMER_LINKS_FAILURE = 'CUSTOMIZATION_CUSTOMER_LINKS_FAILURE';
